import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.custom-table-class .p-sortable-column-icon {
   color: ${dt('text.muted.color')};
}

table {
 & td {
  vertical-align: top;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: 400;
  }
 & th {
  font-size: 0.75rem;
  line-height: 1.25rem;
  }
}

/*
 * The cell a table shows across all its columns while it has no rows. The element chain plus the class outranks the
 * body cell rule of every table (library and plain-table cells, the editable row table).
 */
table > tbody > tr > td.app-data-table-empty {
  text-align: center;
  color: ${dt('appDataTable.empty.color')};
  font-size: ${dt('appDataTable.empty.fontSize')};
  line-height: ${dt('appDataTable.empty.lineHeight')};
  padding: ${dt('appDataTable.empty.padding')};
}
`;
